import React from 'react';

export default function LogoutModal({ onClose }) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-6 max-w-sm w-full text-center space-y-4 m-8">
        <h2 className="text-xl font-bold">Goodbye!</h2>
        <p className="text-sm text-gray-600">
          Thank you! You have successfully logged out. We hope to see you again soon!
        </p>
        <button
          className="mt-4 w-full bg-blue-600 text-white py-2 rounded-lg font-medium"
          onClick={() => onClose(false)}
        >
          Close
        </button>
      </div>
    </div>
  );
}
